import {buttonEnum} from "./helper";
import PlayButton from "./Audio/play-button";
import VrButtonContainer from "./VRMenu/vr-button-container";

class ButtonController {
    buttons = [];

    constructor() {
    }

    addButton(button) {
        this.buttons.push(button);
    }

    getButtonByName(buttonName) {
        if (!wv.settings.featuresEnabled.isSceneMenuEnabled) {
            return;
        }

        for (const button of this.buttons) {
            if (button.name === buttonName) {
                return button;
            }

        }
        return this.createButton(buttonName);
    }

    createButton(buttonName) {
        let button;
        switch (buttonName) {
            case buttonEnum.PLAY:
                button = new PlayButton();
                break;
            case buttonEnum.MENU:
            case buttonEnum.MENU_TOGGLE:
                button = VrButtonContainer.getInstance().createMenuButton(buttonName);
                break;
            default:
                throw new Error(`Unsupported button type: ${buttonName}`);
        }
        this.addButton(button);
        return button;
    }

    hasButton(id) {
        if (!id) {
            return false;
        }

        return !!this.getButtonByID(id);
    }

    getButtonByID(id) {
        for (const button of this.buttons) {
            if (button.buttonContainer.buttonID === id) {
                return button;
            }

        }
    }

    onButtonClick(id) {
        const button = this.getButtonByID(id);
        button.callback();
    }

    onVRModeChange() {
        for (const button of this.buttons) {
            button.onVRModeChange();
        }
    }
}

export default ButtonController;